import React, { useEffect } from "react";
import { useRouter } from "next/router";

import AuthorData from "../../../data/authors.json";
// import BlogData from "../../../data/tfm/terraform-modules.json";
import PageHead from "@/pages/Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import BlogDetails from "@/components/Blogs/BlogDetails";
import BlogListItems from "@/components/Blogs/Blog-Sections/BlogList-Items";
import Instagram from "@/components/Instagram/Instagram";
import BlogBreadCrumb from "@/components/Common/Blog-BreadCrumb";
// import { serialize } from 'next-mdx-remote/serialize'
// import { MDXRemote } from 'next-mdx-remote'
// import { readFile } from 'fs/promises'
import Link from "next/link";
// import rehypePrism from 'rehype-prism-plus';
// import rehypeCodeTitles from 'rehype-code-titles';
import TFModuleDetails from "@/components/TFModule/TFModuleDetails";
import CPStaticContent from '../../../models/CPStaticContent.js'

export default function SingleBlog(tfModule) {
  const router = useRouter();

  const moduleId = router.query.moduleId;
  const mdxSource = tfModule.content
  const allModules = tfModule.list
  const moduleInfo = tfModule.info

  // const moduleInfo = allModules.find((item) => item.content_id === moduleId);
  // const downloads = moduleInfo.downloads

  const authors = JSON.parse(JSON.stringify(AuthorData.authorList));
  const Author = authors.find((author) => author.id === "akbar-hussain");
  moduleInfo['author'] = [Author]
  // const moduleInfo = moduleInfo

  const shortDesc = "Official documentation for the Terraform Module [" + moduleInfo.tf_module_name + "] published by CloudPedia.AI"
  moduleInfo.description['short'] = shortDesc

  useEffect(() => {
    if (moduleId && !moduleInfo) {
      router.push("/blog-list");
    }
  }, [moduleInfo, router]);

  return (
    <>
      <PageHead post={moduleInfo} category={"Terraform Module Documentation"} />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <div className="rbt-overlay-page-wrapper">
            <BlogBreadCrumb matchedBlog={moduleInfo} categoryName={"Terraform Modules"} categoryPath={"/terraform-modules"} />

            <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
              <div className="blog-content-wrapper rbt-article-content-wrapper">

                <TFModuleDetails
                  blogType={"terraform-module"}
                  tfModuleInfo={moduleInfo !== undefined ? moduleInfo : ""}
                  blogContent={mdxSource}
                  author={Author}
                />

                <div className="related-post pt--60">
                  <div className="section-title text-start mb--40">
                    <span className="subtitle bg-primary-opacity">
                      continue exploring
                    </span>
                    <h4 className="title">Other Modules from CloudPedia</h4>
                  </div>
                  <BlogListItems
                    blogType={"terraform-module"}
                    selectedBlogs={allModules}
                    itemIdToAvoid={moduleId}
                    start={0}
                    end={10}
                  />
                </div>
                <br />
                <Link className="rbt-btn rbt-switch-btn btn-border" href="/terraform-modules/">
                  <span data-text="View all Modules">View all Modules</span>
                </Link>

              </div>
            </div>

            {/* <div className="row">
              <div className="col-lg-12">
                <div className="load-more mt--60 text-center">
                  <Link className="rbt-btn rbt-switch-btn btn-border" href="/terraform-modules/">
                    <span data-text="View More Events">View More Events</span>
                  </Link>
                </div>
              </div>
            </div> */}

            <Instagram />
          </div>

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("tfmdocs")
  await stContent.fetchContent()
  return await stContent.getItemProps(context.params.postId)
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("tfmdocs")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}
